var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgOlo(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 24,
    viewBox: "0 0 39 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3656_413)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.82987 16.2064C10.1138 16.2064 11.9614 14.3203 11.9614 11.9945C11.9614 9.67268 10.1138 7.787 7.82987 7.787C5.54595 7.787 3.69834 9.67268 3.69834 11.9945C3.69834 14.3203 5.54595 16.2064 7.82987 16.2064ZM7.83064 4.01904C12.1545 4.01904 15.6613 7.59076 15.6613 11.9945C15.6613 16.3981 12.1545 19.9699 7.83064 19.9699C3.50686 19.9699 0 16.3981 0 11.9945C0 7.59076 3.50686 4.01904 7.83064 4.01904Z",
    fill: "#3599FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1101 16.2064C28.8262 16.2064 26.9786 14.3203 26.9786 11.9945C26.9786 9.67268 28.8262 7.787 31.1101 7.787C33.3941 7.787 35.2417 9.67268 35.2417 11.9945C35.2417 14.3203 33.3941 16.2064 31.1101 16.2064ZM31.1109 4.01904C26.7871 4.01904 23.2803 7.59076 23.2803 11.9945C23.2803 16.3981 26.7871 19.9699 31.1109 19.9699C35.4347 19.9699 38.9415 16.3981 38.9415 11.9945C38.9415 7.59076 35.4347 4.01904 31.1109 4.01904Z",
    fill: "#3599FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8701 24H21.5673V0H17.8701V24Z",
    fill: "#3599FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3656_413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgOlo);
export default __webpack_public_path__ + "static/media/img_olo.aebfae32c19edbbf8f314677a1ce7e5a.svg";
export { ForwardRef as ReactComponent };